import { render, staticRenderFns } from "./flats-crm-card.vue?vue&type=template&id=a20c48ec"
import script from "./flats-crm-card.vue?vue&type=script&lang=js"
export * from "./flats-crm-card.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-card.vue?vue&type=style&index=0&id=a20c48ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports